import React from 'react';
import { Card } from 'primereact/card';
import { bionicText } from '../../../../utils/bionicText';

const AboutSection = ({ ABOUT_CARDS = [], BRAND_NAME, bionicEnabled }) => (
  <div className="about-section">
    <h2 className="section-title" key="about-title">{bionicEnabled ? bionicText(`About ${BRAND_NAME}`) : `About ${BRAND_NAME}`}</h2>
    <h3 className="section-subTitle" key="about-subtitle">{bionicEnabled ? bionicText('Flexible Solutions for Every Need') : 'Flexible Solutions for Every Need'}</h3>
    <div className="about-content">
      {ABOUT_CARDS.map((card, idx) => (
        <Card 
          className="about-card" 
          key={`about-card-${card.title}-${idx}`}
        >
          <h3 key={`about-card-title-${idx}`}>
            <i className={`${card.icon} mr-3`} style={{ fontSize: '2rem' }} /> {bionicEnabled ? bionicText(card.title) : card.title}
          </h3>
          <p key={`about-card-description-${idx}`}>
            {bionicEnabled ? bionicText(card.description) : card.description}
          </p>
        </Card>
      ))}
    </div>
  </div>
);

export default React.memo(AboutSection);
